import React from "react";

interface TextBoxProps {
  condition: boolean;
  defaultColor: string;
  accentColor: string;
  children: React.ReactNode;
}

const TextBox: React.FC<TextBoxProps> = ({
  condition,
  defaultColor,
  accentColor,
  children,
}) => {
  return (
    <span
      data-testid="text-box"
      style={{ color: condition ? accentColor : defaultColor }}
      className="analysis-no-text"
    >
      {children}
    </span>
  );
};

export default TextBox;
